import { Icon } from '@ps/sports-ui-component-library';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import StarSub from '@swf/generated/sports-icons/starSub';

import type { MeetingBasedDescriptionProps } from './MeetingBasedDescription';
import { MeetingBasedDescription } from './MeetingBasedDescription';
import { TXTWCL_Star_Sub_enabled_selection } from './OpportunityDescription.messages.json';
import styles from './OpportunityDescrption.scss';

interface Props extends MeetingBasedDescriptionProps {
  className?: string;
  isStarSubEnabled?: boolean;
}

export const OpportunityDescription: React.FC<Props> = ({
  className,
  description,
  venue,
  marketTime,
  variant,
  isStarSubEnabled
}) => {
  const { formatMessage } = useRegulatoryIntl();

  if (venue) {
    return (
      <MeetingBasedDescription
        variant={variant}
        className={className}
        marketTime={marketTime}
        venue={venue}
        description={description}
      />
    );
  }

  return (
    <span className={className}>
      {description}
      {isStarSubEnabled ? (
        <Icon
          icon={StarSub}
          className={styles.starSubIcon}
          label={formatMessage(TXTWCL_Star_Sub_enabled_selection)}
          size="xs"
        />
      ) : null}
    </span>
  );
};
